export default "__VITE_ASSET__C6DvvKL2__"